"use client";

import { useState } from "react";
import type { TravelAgency } from "@/lib/findAgent";
import styles from "./find-agent.module.css";

function AgentLogo({ src, name }: { src?: string; name: string }) {
  const [hidden, setHidden] = useState(!src);

  if (hidden) return null;

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      className={styles.agentLogo}
      src={src}
      alt={name}
      onError={() => setHidden(true)}
    />
  );
}

function AgentInitials({ name }: { name: string }) {
  const initials = name
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

  return <div className={styles.agentInitials}>{initials}</div>;
}

interface AgentCardProps {
  agency: TravelAgency;
  index: number;
}

export default function AgentCard({ agency, index }: AgentCardProps) {
  const loc = agency.locationInformation?.[0];
  const addr = loc?.tnAddress;
  const phone = loc?.phone1 || loc?.phone2;
  const hasLogo = !!agency.logo;

  return (
    <div className={styles.agentCard}>
      <a
        href={phone ? `tel:${phone}` : undefined}
        className={styles.agentCardInner}
        style={phone ? undefined : { cursor: "default" }}
      >
        <div className={styles.agentTop}>
          <span className={styles.agentIndex}>{index}</span>
          {hasLogo ? (
            <AgentLogo src={agency.logo} name={agency.name} />
          ) : (
            <AgentInitials name={agency.name} />
          )}
        </div>

        <div className={styles.agentInfo}>
          <p className={styles.agentName}>{agency.name}</p>
          {addr && (
            <p className={styles.agentAddress}>
              <i className="fa-light fa-location-dot" />
              {addr.streetNumber} {addr.streetName}, {addr.city}, {addr.state}{" "}
              {addr.zip}
            </p>
          )}
          {phone && (
            <div className={styles.agentActions}>
              <span className={styles.agentPhone}>
                <i className="fa-solid fa-phone" />
                {phone}
              </span>
            </div>
          )}
        </div>
      </a>
    </div>
  );
}
